window.addEventListener("trix-file-accept", function(event) {
    const acceptedTypes = ['application/pdf', 'image/jpg','image/jpeg']
    if (!acceptedTypes.includes(event.file.type)) {
      event.preventDefault()
      alert("Solamente se aceptan archivos PDF");
    }
  })